import { Component, OnInit, ChangeDetectorRef } from '@angular/core';
import { AppService } from "../shared/services/app.service";

@Component({
  selector: 'app-printer',
  templateUrl: './printer.component.html',
  styleUrls: ['./printer.component.css']
})
export class PrinterComponent implements OnInit {

  printers:string[] = [];

  constructor(
    private _ref: ChangeDetectorRef,
    private _appService: AppService
  ) {

  }

  ngOnInit() {
    this.printers = this._appService.getPrinters();
  }

  setPrinter(p) {
    this._appService.setInvPrinter(p);
  }

}



// WEBPACK FOOTER //
// ./src/app/inventory/printer.component.ts